export default __webpack_public_path__ + "static/media/ownership-work.6632c7de.png";